"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XalError = void 0;

var XalError =
/** @class */
function (_super) {
  __extends(XalError, _super);

  function XalError(errorType, message) {
    var _this = _super.call(this, "XAL error: " + errorType + ": " + message) || this;

    _this.errorType = errorType;
    return _this;
  }

  return XalError;
}(Error);

exports.XalError = XalError;